// extracted by mini-css-extract-plugin
module.exports = {"container":"DialogHeader_container__VTTdN"};